/** See `src/i18n/locales/en/audit.ts`. */
export const audit = {
  page: {
    title: 'Audit-Protokoll',
    scopedLead:
      'Du siehst die zugelassenen Aktionen für deine eigenen Unternehmen; Einwilligungsantworten und Identitätsverknüpfungen werden nie angezeigt.',
    actionFilter: 'Nach Aktion filtern',
    actionPlaceholder: 'Aktion, z. B. department.visibility.update',
    scopeFilter: 'Nach Geltungsbereich filtern',
    scopePlaceholder: 'Geltungsbereich-ID',
    filter: 'Filtern',
    empty: 'Keine Audit-Zeilen.',
    when: 'Wann',
    action: 'Aktion',
    actorRole: 'Rolle des Ausführenden',
    target: 'Ziel',
    rowsLabel: 'die Audit-Zeilen',
  },
} as const;
